module.exports = __webpack_public_path__ + "img/1.f535ee4.svg";